import { createContext, useContext } from 'react';

export interface User {
    name: string;
}

export interface AuthContextType {
    isLoggedIn: boolean;
    user: User | null;
    loading: boolean;
    login: () => void;
    logout: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
